/* SAPSAN - strona główna v2: zakładki produktów, dodawanie do koszyka w tle, newsletter Klaviyo.
   Bez tego pliku wszystko działa: zakładki to linki do kolekcji, koszyk to zwykły formularz. */
(function () {
  'use strict';
  var lang = (document.documentElement.lang || 'pl').slice(0, 2);
  var T = {
    pl: { added: 'Dodano do koszyka.', view: 'Zobacz koszyk', fail: 'Nie udało się dodać. Spróbuj ponownie.' },
    en: { added: 'Added to cart.', view: 'View cart', fail: 'Could not add to cart. Please try again.' },
    de: { added: 'Zum Warenkorb hinzugefügt.', view: 'Warenkorb ansehen', fail: 'Hinzufügen fehlgeschlagen. Bitte erneut versuchen.' },
    cs: { added: 'Přidáno do košíku.', view: 'Zobrazit košík', fail: 'Přidání se nezdařilo. Zkuste to znovu.' },
    ru: { added: 'Добавлено в корзину.', view: 'Открыть корзину', fail: 'Не удалось добавить. Попробуйте ещё раз.' }
  }[lang] || null;
  if (!T) T = { added: 'Added to cart.', view: 'View cart', fail: 'Could not add to cart. Please try again.' };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---- zakładki produktów (Section Rendering API) ---- */
  var cache = {};
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-sh-tab]');
    if (!tab || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    var sec = tab.closest('.sh-prod');
    var grid = sec && sec.querySelector('[data-sh-grid]');
    if (!grid) return;
    e.preventDefault();
    var href = tab.getAttribute('href');
    var show = function (html) {
      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');
      sec.querySelectorAll('[data-sh-tab]').forEach(function (t) { t.removeAttribute('aria-current'); });
      tab.setAttribute('aria-current', 'true');
      sec.querySelectorAll('[data-sh-more]').forEach(function (m) { m.setAttribute('href', href); });
    };
    if (cache[href]) return show(cache[href]);
    grid.setAttribute('aria-busy', 'true');
    fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=sapsan-home-grid', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (txt) {
        var tpl = document.createElement('template');
        tpl.innerHTML = txt;
        var wrap = tpl.content.querySelector('.shopify-section') || tpl.content;
        var html = wrap.innerHTML.trim();
        if (!html) throw new Error('empty');
        cache[href] = html;
        show(html);
      })
      .catch(function () { window.location.href = href; });
  });

  /* ---- dodawanie do koszyka w tle ---- */
  function setCount(n) {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', n > 0 ? n : '');
      el.classList.toggle('visible', n > 0);
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches) return;
    if (form.matches('[data-sh-atc]')) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var msg = form.querySelector('[data-sh-added]');
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      /* 25.09.2026: najpierw koszyk założony na starcie sesji (layout, window.sapsanCartReady), a 2 s po dodaniu sprawdzenie koszyka
         i ponowne dodanie tylko brakującego wariantu - zabezpieczenie przed wyścigiem z zapisem atrybutów Analyzify (jak na karcie produktu). */
      var fd = new FormData(form);
      var addReq = function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd, credentials: 'same-origin' }); };
      Promise.resolve(window.sapsanCartReady).catch(function () {}).then(addReq)
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (item) {
          setTimeout(function () {
            fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
              var has = (c.items || []).some(function (i) { return item && i.variant_id === item.variant_id; });
              if (item && !has) return addReq().then(function () { return fetch(root + 'cart.js', { credentials: 'same-origin' }); }).then(function (r) { return r.json(); }).then(function (c2) { setCount(c2.item_count); });
            }).catch(function () {});
          }, 2000);
          if (msg) {
            msg.textContent = T.added + ' ';
            var a = document.createElement('a');
            a.href = root + 'cart';
            a.textContent = T.view;
            msg.appendChild(a);
            msg.classList.remove('sh-vh');
          }
          return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
        })
        .catch(function (err) {
          if (msg) { msg.textContent = (err && err.description) || T.fail; msg.classList.remove('sh-vh'); }
        })
        .then(function () { btn.removeAttribute('aria-busy'); });
      return;
    }
    if (form.matches('[data-sh-nl]')) {
      e.preventDefault();
      nlSubmit(form);
    }
  });

  /* ---- newsletter (Klaviyo Client API) ---- */
  document.querySelectorAll('[data-sh-nl]').forEach(function (form) {
    var consent = form.querySelector('input[name="consent"]');
    var btn = form.querySelector('button[type="submit"]');
    btn.disabled = !consent.checked;
    consent.addEventListener('change', function () {
      btn.disabled = !consent.checked;
      if (consent.checked) { consent.removeAttribute('aria-invalid'); form.querySelector('[data-err]').hidden = true; }
    });
  });
  function nlSubmit(form) {
    var ok = form.querySelector('[data-ok]'), err = form.querySelector('[data-err]');
    var defErr = err.getAttribute('data-default') || err.textContent;
    err.setAttribute('data-default', defErr);
    ok.hidden = true; err.hidden = true; err.textContent = defErr;
    if (form.querySelector('input[name="company_website"]').value) return;
    var consent = form.querySelector('input[name="consent"]');
    var emailEl = form.querySelector('input[name="email"]');
    var email = (emailEl.value || '').trim();
    if (!consent.checked) { err.textContent = form.dataset.errConsent || defErr; err.hidden = false; consent.setAttribute('aria-invalid', 'true'); consent.focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = form.dataset.errEmail || defErr; err.hidden = false; emailEl.focus(); return; }
    var btn = form.querySelector('button[type="submit"]');
    btn.disabled = true;
    var body = { data: { type: 'subscription', attributes: { custom_source: 'shopify_custom_form_inline', profile: { data: { type: 'profile', attributes: {
      email: email, properties: { preferred_language: form.dataset.lang || lang, country: form.dataset.country || undefined } } } } },
      relationships: { list: { data: { type: 'list', id: form.dataset.list } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.site), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      ok.hidden = false; form.reset(); btn.disabled = true;
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
    }).catch(function () { err.hidden = false; btn.disabled = !consent.checked; });
  }

  /* ---- spis kategorii: przyklejony pod nagłówkiem sklepu tylko wtedy, gdy mieści się w oknie ---- */
  var catIntro = document.querySelector('.sh-cat__intro');
  if (catIntro) {
    var wide = window.matchMedia('(min-width: 990px)');
    var fitIntro = function () {
      var head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 110;
      catIntro.classList.toggle('sh-cat__intro--sticky', wide.matches && catIntro.offsetHeight + head + 32 <= window.innerHeight);
    };
    fitIntro();
    window.addEventListener('resize', fitIntro, { passive: true });
    window.addEventListener('load', fitIntro);
    if (window.ResizeObserver) new ResizeObserver(fitIntro).observe(catIntro);
  }
})();
